// imported from https://github.com/component/has-cors
let value = false;
try {
    value = typeof XMLHttpRequest !== 'undefined' &&
        'withCredentials' in new XMLHttpRequest();
}
catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
}
export const hasCORS = value;



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/build/esm/contrib/has-cors.js
// module id = 1635
// module chunks = 0